import OrganisationLogo from "../organisation-logo/organisation-logo";
import SupportButton from "../organisation-support-button/organisation-support-button";

import { Link } from "react-router-dom";
import OrganisationTitle from "../organisation-title/organisation-title.tsx";

const OrganisationSupportElement = ({
  organisation,
  values,
  setValues,
  showSupportButton = true,
  onSupportClick = null,
  onAddNewOrganisation = (p) => {},
  onCancelOrganisation = (p) => {},
  subtitle = null,
}) => {
  const isSupporting = values.some(
    (v) => v.organisation && v.organisation.id === organisation.id
  );

  const to = `/raindrop/organisation/${organisation.id}`;

  if (!organisation) {
    organisation = {
      id: "test",
      title: "Test Organisation",
      supporters: 100,
    };
  }

  return (
    <div className={"flex flex-row w-full items-center justify-between"}>
      <Link
        id={"search-result-" + organisation.id}
        key={"search-result-" + organisation.id}
        to={to}
        className="flex flex-row w-full transition-all duration-200"
      >
        <div
          id={"logo-title-and-info"}
          className={"flex flex-row items-center gap-3 w-full"}
        >
          <OrganisationLogo src={organisation.presignedUrlLogo} />
          <div className={"flex flex-col items-start w-full"}>
            <h4 className="text-xs font-bold text-color-dark-text-tertiary">
              Organisation
            </h4>

            <OrganisationTitle
              title={organisation.name}
              isHydrated={organisation.isHydrated}
            />

            {subtitle && (
              <div
                id={"organisation-sub-heading"}
                className={"text-xs text-color-text-secondary"}
              >
                {subtitle}
              </div>
            )}
          </div>
        </div>
      </Link>

      {showSupportButton && (
        <SupportButton
          organisationId={organisation.id}
          values={values}
          setValues={setValues}
          isSupporting={isSupporting}
          onSupportClick={onSupportClick}
          onClick={() => onAddNewOrganisation({ organisation: organisation })}
          onCancel={() => onCancelOrganisation({ organisation: organisation })}
          isShowingPauseOption={false}
        />
      )}
    </div>
  );
};

export default OrganisationSupportElement;
